import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Mail } from 'lucide-react';

const Footer = () => (
  <footer style={{ background: 'var(--dark)', borderTop: '1px solid var(--border)', padding: '64px 0 32px' }}>
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '40px', marginBottom: '48px' }}>
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '28px', color: 'var(--gold)', marginBottom: '16px', letterSpacing: '0.1em' }}>LUMIÈRE</div>
          <p style={{ fontSize: '12px', color: 'var(--white-dim)', lineHeight: 1.8, letterSpacing: '0.05em' }}>
            The art of fragrance. Handcrafted luxury perfumes that tell your unique story.
          </p>
          <div style={{ display: 'flex', gap: '16px', marginTop: '20px' }}>
            {[Instagram, Twitter, Facebook, Mail].map((Icon, i) => (
              <button key={i} style={{ background: 'none', color: 'var(--white-dim)', transition: 'color 0.3s', padding: 0 }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--gold)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--white-dim)'}
              ><Icon size={16} /></button>
            ))}
          </div>
        </div>

        {[
          { title: 'NAVIGATE', links: [['Home', '/'], ['Collection', '/collection'], ['AI Advisor', '/ai-advisor']] },
          { title: 'ACCOUNT', links: [['Sign In', '/login'], ['Register', '/register'], ['My Profile', '/profile'], ['My Orders', '/profile']] },
          { title: 'INFO', links: [['About Us', '/'], ['Privacy Policy', '/'], ['Terms of Service', '/'], ['Contact', '/']] },
        ].map(({ title, links }) => (
          <div key={title}>
            <h4 style={{ fontSize: '10px', letterSpacing: '0.25em', color: 'var(--gold)', marginBottom: '20px', fontWeight: 600 }}>{title}</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {links.map(([label, path]) => (
                <li key={label}>
                  <Link to={path} style={{ fontSize: '12px', color: 'var(--white-dim)', letterSpacing: '0.05em', transition: 'color 0.3s' }}
                    onMouseEnter={e => e.target.style.color = 'var(--gold)'}
                    onMouseLeave={e => e.target.style.color = 'var(--white-dim)'}
                  >{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <p style={{ fontSize: '11px', color: 'var(--white-faint)', letterSpacing: '0.05em' }}>
          © {new Date().getFullYear()} Lumière. All rights reserved.
        </p>
        <p style={{ fontSize: '11px', color: 'var(--white-faint)', letterSpacing: '0.05em' }}>
          Crafted with passion for fragrance
        </p>
      </div>
    </div>
    <style>{`
      @media (max-width: 768px) {
        footer .container > div:first-child { grid-template-columns: 1fr 1fr !important; }
      }
      @media (max-width: 480px) {
        footer .container > div:first-child { grid-template-columns: 1fr !important; }
      }
    `}</style>
  </footer>
);

export default Footer;
